import { resourceText } from 'src/app/shared/services/localization';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { isCheckinReturnUrl } from '../../self-checkin/self-checkin-flow.service';
import { Router, ActivatedRoute } from '@angular/router';
import { GlobalService } from 'src/app/shared/services/global.service';
import { TenantService } from 'src/app/tenant/tenant.service';
import { AuthService } from '../auth.service';
import { ResetRequest } from './reset-request.model';

@Component({
    selector: 'app-reset-request',
    templateUrl: './reset-request.component.html',
    styleUrls: ['./reset-request.component.scss'],
    standalone: false
})
export class ResetRequestComponent implements OnInit, AfterViewInit {
  resetRequestForm: FormGroup = new FormGroup({});
  isLoading: boolean = false;
  error: string = null;
  resetRequestComplete: boolean = false;
  failureClosed: boolean = true;
  isEmail: boolean = true;
  phoneNumber: string = '';
  dial_code: string = '';
  reset_token: string = '';
  verifyPhone: boolean = false;
  failedToVerify: boolean = false;
  subdomain: string = "";
  returnUrl = '';
  recoveryMessage = '';
  recoveryStatus = '';
  emailOnly = false;
  phoneProof = "";

  constructor(
    private authService: AuthService,
    public globalService: GlobalService,
    private tenantService: TenantService,
    private _router: Router,
    private route: ActivatedRoute,
  ) { }
  

  async ngOnInit() {
    this.isLoading = true;
    var simple = await this.tenantService.getSimpleTenant();
    this.subdomain = simple.subdomain;
    const destination = this.route.snapshot.queryParams['returnUrl'] || sessionStorage.getItem('CSCheckinReturn:' + this.subdomain);
    if (isCheckinReturnUrl(destination, this.subdomain)) this.returnUrl = destination;
    this.emailOnly = simple.accountVerificationMethod === "email";
    this.dial_code = simple.dialCode.toString();
    this.resetRequestForm = new FormGroup({
      email: new FormControl(null, [Validators.required]),
    });
    this.resetRequestForm.reset();

    this.isLoading = false;
  }

  ngAfterViewInit() {
    setTimeout(() => {
    this.globalService.title.push(this.globalService.screenHeader);
    this.globalService.screenHeader = "";
    });
  }      


  clearCellPhone() {   
    this.reloadCurrentRoute();
  }

  reloadCurrentRoute() {
    const currentUrl = this._router.url;
    this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this._router.navigate([currentUrl]);
    });
  }  

  failedVerification() {
      this.verifyPhone = false;
      this.failedToVerify = true;
  }

  ConfirmCellPhone(phoneNumber)
  {
    const resetRequest: ResetRequest = {
      email: this.phoneNumber,
    };
    this.authService.getPhoneResetToken(resetRequest, this.phoneProof).subscribe(
      (data) => {
        this.reset_token = data['token'];
        var encodedPhone = encodeURIComponent(this.phoneNumber).replace('%20','+');
        var encodedToken = encodeURIComponent(this.reset_token).replace('%20','+');
        this._router.navigateByUrl(this.subdomain + '/resetpassword/'+ encodedPhone + '/' + encodedToken + (this.returnUrl ? '?returnUrl=' + encodeURIComponent(this.returnUrl) : ''));
      }
    )
  }

  onSubmit() {

    if (!this.resetRequestForm.valid) {
      this.failureClosed = false;
      return;
    }

    var email = this.resetRequestForm.get('email').value;

    if (email.indexOf('@') >= 0)
      this.isEmail = true;
    else {
      this.isEmail = false;
      this.phoneNumber = email.replace(/\D/g, "");
    }

    const resetRequest: ResetRequest = {
      email: email,
      returnUrl: this.returnUrl,
    };
    if (this.isEmail == true)
      this.authService.requestReset(resetRequest).subscribe(
        (data) => {
          this.recoveryStatus = data['status'] || '';
          this.recoveryMessage = data['message'] || resourceText('UI_UNABLE_TO_CONFIRM_A_PASSWORD_RESET_EMAIL_PLEASE_TRY_AGAIN');
          this.resetRequestComplete = this.recoveryStatus === 'sent';
          this.error = this.resetRequestComplete ? null : this.recoveryMessage;
          this.failureClosed = this.resetRequestComplete;
          this.isLoading = false;
        },
        (errorMessage) => {
          this.error = errorMessage.message;
          this.resetRequestComplete = false;
          this.failureClosed = false;
          this.isLoading = false;
        }
      );
    else
    {
      this.error = null;
      if (this.emailOnly) { this.error = resourceText('ENTER_YOUR_VERIFIED_EMAIL_ADDRESS_TO_RESET_YOUR_PASSWORD'); this.failureClosed = false; return; }
      this.verifyPhone = true;
      this.failureClosed = true;
    }
  }
}
